import React, { useState } from "react";
import styles from "./OptionalGroup.module.scss"
import typography from "./../typography.module.scss"
import classNames from "classnames";
import {TransitionChevron} from "./../Widgets";
import {UnmountClosed} from 'react-collapse';
import _ from "lodash";

export default ({children, className, style, defaultValue = false, contentClassName, title, Title, Component = "button", optional, onClick: _onClick, isOpen: _isOpen, id}) => {
    const hasParent = !!_onClick;
    const items = children ? _.isArray(children) ? children : [children] : null;
    const [isOpen, setIsOpen] = useState(defaultValue);
    const pOpen = _onClick ? _isOpen : isOpen;
    const onClick = () => {
        _onClick ? _onClick(id) : setIsOpen(!isOpen);
    };

    return <div className={classNames(styles.base, className)} style={style}>
        <Component className={styles.header} onClick={e => onClick(e)}>
            {Title && <Title isOpen={pOpen}/>}
            {title && title}
            {optional && <span color={"text-secondary"}>(Optional)</span>}
            <TransitionChevron isActive={pOpen} className={styles['slider-chevron']}/>
        </Component>
        <UnmountClosed
            isOpened={pOpen} theme={{collapse: styles['animation']}}>
            <div className={contentClassName}>
                {!hasParent && children}
                {hasParent && items && items.map((child, index) => {
                    if(child) {
                        const clone = React.cloneElement(child, { close: onClick });
                        return <React.Fragment key={index}>
                            {clone}
                        </React.Fragment>
                    } else {
                        return ""
                    }
                })}
            </div>
        </UnmountClosed>
    </div>
};
